export class FormValidation {

    constructor(form) {
        this.form = form;

        if(this.form !== null) {
            this.instantiateInputs();
        }
    }

    instantiateInputs(){
        this.inputs = this.form.querySelectorAll('input, select, textarea');

        this.inputs.forEach((input)=>{
            input.addEventListener('change', e=>this.inputChange(input));
            input.addEventListener('focus', e=>this.inputFocus(input));
        });
    }

    inputChange(input) {
        this.validateField(input, false);
    }

    inputFocus(input) {
        this.hideValidatonError(input);
    }

    validateFields() {
        this.valid = true;

        this.inputs.forEach((input)=>{
            this.validateField(input);
        });

        return this.valid;
    }

    validateField(input, showError = true) {
        let requiredType = input.getAttribute('data-required');
        if(requiredType !== null) {

            let inputValue = input.value,
                humanReadable = 'value',
                aan = 'A',
                testRegex = null;

            switch (requiredType) {
                case 'email':
                    testRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    humanReadable = 'email address';
                    aan = 'An';
                    break;
                case 'phone':
                    testRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
                    humanReadable = 'phone number';
                    break;
            }

            if(inputValue === '') {
                if(showError) {
                    this.throwValidationError(aan + ' ' + humanReadable + ' is required.', input);
                }
                return false;
            }

            if(testRegex) {
                if(!testRegex.test(inputValue)) {
                    if(showError) {
                        this.throwValidationError('A valid ' + humanReadable + ' is required.', input);
                    }
                    return false
                }
            }

            this.clearValidatonError(input);
            return true;

        } else {
            this.clearValidatonError(input);
            return true;
        }
    }

    throwValidationError(error, input) {
        let parent = input.parentNode,
            validationElement = parent.querySelector('.validation-error');

        this.valid = false;

        if(validationElement === null) {
            validationElement = document.createElement('div');
            validationElement.classList.add('validation-error');
            validationElement.innerHTML = error;
            parent.appendChild(validationElement);

        } else {
            validationElement.innerHTML = error;
        }
        validationElement.classList.remove('hide');

        input.classList.add('invalid');
    }

    clearValidatonError(input) {
        input.classList.remove('invalid');
        this.hideValidatonError(input);
    }

    hideValidatonError(input) {
        let parent = input.parentNode,
            validationElement = parent.querySelector('.validation-error');

        if(validationElement !== null) {
            validationElement.classList.add('hide');
        }
    }

    makeRequiredField(input, type = ''){
        input.setAttribute('data-required', type);

        let placeholder = input.getAttribute('placeholder').replace('*', '');
        input.setAttribute('placeholder', placeholder + '*');
    }

    makeOptionalField(input) {
        input.removeAttribute('data-required');
        let placeholder = input.getAttribute('placeholder').replace('*', '');
        input.setAttribute('placeholder', placeholder);
    }
}


// WEBPACK FOOTER //
// ./assets/js/libraries/validation.js